"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Communication = void 0;
const toccata_1 = require("@musicaudienceexchange/toccata");
class Communication extends toccata_1.Model {
}
Communication.defaults = {
    status: "pending",
};
__decorate([
    toccata_1.validator.IsObject()
], Communication.prototype, "data", void 0);
__decorate([
    toccata_1.validator.IsOptional(),
    toccata_1.validator.IsString()
], Communication.prototype, "email", void 0);
__decorate([
    toccata_1.validator.IsOptional(),
    toccata_1.validator.IsString()
], Communication.prototype, "phone", void 0);
__decorate([
    toccata_1.validator.IsOptional(),
    toccata_1.validator.IsString()
], Communication.prototype, "uid", void 0);
__decorate([
    toccata_1.validator.IsString()
], Communication.prototype, "templateId", void 0);
__decorate([
    toccata_1.validator.IsString()
], Communication.prototype, "status", void 0);
__decorate([
    toccata_1.validator.IsString(),
    toccata_1.validator.IsOptional()
], Communication.prototype, "from", void 0);
__decorate([
    toccata_1.validator.IsNumber(),
    toccata_1.validator.IsOptional()
], Communication.prototype, "version", void 0);
__decorate([
    (0, toccata_1.TransformValidateDateTime)()
], Communication.prototype, "createdAt", void 0);
exports.Communication = Communication;
/*
export interface MessagePayload<T> {
  from?: string;
  subject?: string;
  language?: string;
  message: T;
}

export interface Message<T extends keyof typeof Messages> {
  email: string;
  templateId: T;
  data: MessagePayload<Parameters<typeof Messages[T]>[0]>;
  uid?: string;
}
*/
/**
 * Send a new communication.
 */
/*
 export const send = async (options: CommunicationOptions) => {
    return admin
      .firestore()
      .collection("communications")
      .add({
        createdAt: admin.firestore.FieldValue.serverTimestamp(),
        data: options.data,
        from: options.from || "Set.Live <noreply@set.live>",
        templateId: options.templateId,
        status: "pending",
        ...options.recipient,
      });
  };
*/
//# sourceMappingURL=communications.js.map